<template>
  <div v-if="user" class="snaps-page">
    <div class="pub-head">
      <div class="pub-head-text">
        <div class="pub-heading">Earn Snaps</div>
        <div class="pub-subheading">
          Pick & choose how you want to earn snaps on Pubby.
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="pub-options">
      <snaps-option
        v-for="service in services"
        :service="service"
        :key="service.name"
      />
      <div class="clearfix"></div>
    </div>
    <snap-store v-if="false" user="user"></snap-store>
  </div>
</template>

<script>
import SnapsOption from "@/components/Page/SnapsOption";

import Head from "@/components/Page/Head";
import Heading from "@/components/Page/Heading";
import List from "@/components/Book/List";
import Back from "../modules/Back";
import Bus from "../modules/Bus";
import FindBook from "@/components/Page/FindBook";
import SnapStore from "@/components/Page/SnapStore";
import ActivityTimeline from "@/components/Activity/Timeline";
import ReviewChart from "@/components/Book/ReviewChart";
import ResultsTable from "@/components/Book/ResultsTable";
import NoContent from "@/components/Page/NoContent";
import Challenges from "@/components/Challenges/Challenges";
import PowerUps from "@/components/PowerUps/PowerUps";
import { mapState } from "vuex";

export default {
  name: "Page",
  components: {
    Head,
    Heading,
    SnapsOption,
    SnapStore,
  },
  computed: {
    ...mapState({
      user: "user",
      books: "books",
      events: "events",
    }),
  },
  data: function () {
    return {
      services: null,
      jobs: null,
    };
  },
  watch: {
    user(newValue, oldValue) {
      const user = newValue;
      if (user.memberType === 'free') {
        console.log("user is free");
        this.$router.push("/browse");
      }

      if (user.id > 6500) {
        this.services = [
          {
            id: 1,
            name: "read",
            title: "Read",
            description:
              "Earn snaps for each book you choose to read in our library. Our selection changes each day.",
          },
          {
            id: 1,
            name: "friends",
            title: "Invite Friends to Read",
            description:
              "Your friends can read for free, and you'll earn snaps when they write reviews.",
          },
          {
            id: 1,
            name: "publish",
            title: "Publish & Promote",
            description:
              "We offer discounted publishing services to our members. Earn extra snaps when you request any service.",
          },
          {
            id: 1,
            name: "refer",
            title: "Refer Authors",
            description:
              "Invite authors or publishers to Pubby and earn 2,000 snaps for each referral.",
          },
        ];
      } else {
        this.services = [
          {
            id: 1,
            name: "read",
            title: "Read",
            description:
              "Earn snaps for each book you choose to read in our library. Our selection changes each day.",
          },
          {
            id: 1,
            name: "publish",
            title: "Publish & Promote",
            description:
              "We offer discounted publishing services to our members. Earn extra snaps when you request any service.",
          },
          {
            id: 1,
            name: "refer",
            title: "Refer Authors",
            description:
              "Invite authors or publishers to Pubby and earn 2,000 snaps for each referral.",
          },
        ];
      }

      if (user.promo_code === "FIRE") {
        this.services = [
          {
            id: 1,
            name: "read",
            title: "Read",
            description:
              "Earn snaps for each book you choose to read in our library. Our selection changes each day.",
          },
          {
            id: 1,
            name: "friends",
            title: "Invite Friends to Read",
            description:
              "Your friends can read for free, and you'll earn snaps when they write reviews.",
          },
          {
            id: 1,
            name: "refer",
            title: "Refer Authors",
            description:
              "Invite authors or publishers to Pubby and earn 2,000 snaps for each referral.",
          },
        ];
      }
    },
  },
  async mounted() {
    if (this.user && this.user.memberType === 'free') {
      console.log("user is free");
      this.$router.push("/browse");
    }

    if (this.user.id > 6500) {
      this.services = [
        {
          id: 1,
          name: "read",
          title: "Read",
          description:
            "Earn snaps for each book you choose to read in our library. Our selection changes each day.",
        },
        {
          id: 1,
          name: "friends",
          title: "Invite Friends to Read",
          description:
            "Your friends can read for free, and you'll earn snaps when they write reviews.",
        },
        {
          id: 1,
          name: "publish",
          title: "Publish & Promote",
          description:
            "We offer discounted publishing services to our members. Earn extra snaps when you request any service.",
        },
        {
          id: 1,
          name: "refer",
          title: "Refer Authors",
          description:
            "Invite authors or publishers to Pubby and earn 2,000 snaps for each referral.",
        },
      ];
    } else {
      this.services = [
        {
          id: 1,
          name: "read",
          title: "Read",
          description:
            "Earn snaps for each book you choose to read in our library. Our selection changes each day.",
        },
        {
          id: 1,
          name: "publish",
          title: "Publish & Promote",
          description:
            "We offer discounted publishing services to our members. Earn extra snaps when you request any service.",
        },
        {
          id: 1,
          name: "refer",
          title: "Refer Authors",
          description:
            "Invite authors or publishers to Pubby and earn 2,000 snaps for each referral.",
        },
      ];
    }

    if (this.user.promo_code === "FIRE") {
      this.services = [
        {
          id: 1,
          name: "read",
          title: "Read",
          description:
            "Earn snaps for each book you choose to read in our library. Our selection changes each day.",
        },
        {
          id: 1,
          name: "friends",
          title: "Invite Friends to Read",
          description:
            "Your friends can read for free, and you'll earn snaps when they write reviews.",
        },
        {
          id: 1,
          name: "refer",
          title: "Refer Authors",
          description:
            "Invite authors or publishers to Pubby and earn 2,000 snaps for each referral.",
        },
      ];
    }
  },
  async created() {
    if (this.user.id > 6500) {
      this.services = [
        {
          id: 1,
          name: "read",
          title: "Read",
          description:
            "Earn snaps for each book you choose to read in our library. Our selection changes each day.",
        },
        {
          id: 1,
          name: "friends",
          title: "Invite Friends to Read",
          description:
            "Your friends can read for free, and you'll earn snaps when they write reviews.",
        },
        {
          id: 1,
          name: "publish",
          title: "Publish & Promote",
          description:
            "We offer discounted publishing services to our members. Earn extra snaps when you request any service.",
        },
        {
          id: 1,
          name: "refer",
          title: "Refer Authors",
          description:
            "Invite authors or publishers to Pubby and earn 2,000 snaps for each referral.",
        },
      ];
    } else {
      this.services = [
        {
          id: 1,
          name: "read",
          title: "Read",
          description:
            "Earn snaps for each book you choose to read in our library. Our selection changes each day.",
        },
        {
          id: 1,
          name: "publish",
          title: "Publish & Promote",
          description:
            "We offer discounted publishing services to our members. Earn extra snaps when you request any service.",
        },
        {
          id: 1,
          name: "refer",
          title: "Refer Authors",
          description:
            "Invite authors or publishers to Pubby and earn 2,000 snaps for each referral.",
        },
      ];
    }

    if (this.user.promo_code === "FIRE") {
      this.services = [
        {
          id: 1,
          name: "read",
          title: "Read",
          description:
            "Earn snaps for each book you choose to read in our library. Our selection changes each day.",
        },
        {
          id: 1,
          name: "friends",
          title: "Invite Friends to Read",
          description:
            "Your friends can read for free, and you'll earn snaps when they write reviews.",
        },
        {
          id: 1,
          name: "refer",
          title: "Refer Authors",
          description:
            "Invite authors or publishers to Pubby and earn 2,000 snaps for each referral.",
        },
      ];
    }
  },
};
</script>

<style scoped lang="scss">
.snaps-page {
  padding-bottom: 100px;
}

.pub-head {
  max-width: 560px;
  margin: 0 auto;
  padding-top: 4px;
}
.pub-head-icon {
  float: left;
  width: 100px;
}
.pub-head-text {
}
.pub-head-icon-img {
  width: 68px;
  margin: 46px 0 0 0;
}

.pub-heading {
  padding: 30px 0 2px 0;
  text-align: left;
  font-size: 26pt;
  font-weight: 600;
  font-family: $font-family;
  text-align: center;
}
.pub-subheading {
  text-align: left;
  font-size: 14.5pt;
  font-weight: 500;
  font-family: $font-family;
  text-align: center;
}

.pub-options {
  max-width: 1080px;
  margin: 20px auto;
  padding: 0 20px;
  //border-top: 2px solid #eee;
  font-family: $font-family;
}

.content-container {
  max-width: 1000px !important;
  margin-left: 4px;
  border-bottom: 0;
}

.content-challenges {
  max-width: 100% !important;
  border-top: 2px solid #eee;
  //padding-top: 20px;
}
.column-challenges {
  max-width: 710px;
}

.section-divider {
  width: 100%;
  height: 40px;
}

.add-book {
  display: block;
  margin: 0 auto;
  width: 200px;
  height: 52px;
  border-radius: 52px;
  border: 1px solid #ddd;
}
.add-icon {
  float: left;
  width: 32px;
  margin: 0px 0 0 32px;
  font-size: 26pt;
  text-align: center;
  color: #2196f3;
}
.add-label {
  float: left;
  width: 120px;
  margin: 10px 0 0 6px;
  font-size: 15pt;
  font-weight: 600;
  color: #2196f3;
  font-family: "Source Sans Pro";
}

.add-book:hover {
  box-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: scale(1.05);
}
.grow {
  transition: all 0.1s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.activity-col {
  padding-left: 2px;
  max-width: 710px;
  margin: 20px 0;
}

.pub-jobs {
  max-width: 700px;
  margin: 40px auto;
}
.pub-jobs-heading {
  padding: 0.5em 0;
  font-size: 17pt;
  font-weight: 600;
  font-family: $font-family;
  text-align: left;
}

.pub-meet {
  padding: 20px;
  padding-top: 8px;
}

.pub-meet-headshot-col {
  float: left;
  width: 33%;
  text-align: right;
}
.pub-meet-content-col {
  float: left;
  width: 67%;
  font-family: $font-family;
}

.pub-meet-headshot-img {
  border-radius: 100px;
  width: 120px;
  margin-right: 40px;
}
.pub-meet-heading {
  padding: 0.5em 0;
  font-size: 17pt;
  font-weight: 600;
}
.pub-meet-body {
  font-size: 12pt;
  max-width: 580px;
}
.pub-meet-heading-2 {
  padding: 0.5em 0;
  font-size: 14pt;
  font-weight: 700;
}
.pub-meet-testimonial {
  font-size: 12pt;
  max-width: 580px;
  padding-left: 40px;
}
.pub-meet-byline {
  text-align: right;
  font-size: 12pt;
  max-width: 580px;
  font-style: italic;
  padding-top: 0.2em;
  padding-bottom: 1em;
}

@media (max-width: 1024px) {
  .add-book-container {
    padding-bottom: 20px;
  }

  .activity-col {
    padding-left: 0;
  }
}
</style>